// local development
// export const APIURL = "http://172.25.0.6:9999/services/";
// AWS
export const APIURL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/services/";
// Alpharetta, Non-Dockerized Environments (ATL Prod, PIT Prod, PIT Beta, iPool, UAE Non-Docker)
// export const APIURL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/capdadmin/";
// Non-Dockerized Environment (ATL Beta)
// export const APIURL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/capdadmin2/";
// Beta FFI
// export const APIURL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/capdadminffi/";
// UAE Dockerized
// export const APIURL = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/capdadmin/";
